import React from 'react';

interface BadgeProps {
  status: string;
  className?: string;
}

export function Badge({ status, className = '' }: BadgeProps) {
  const norm = (status || 'OFFLINE').toUpperCase();
  const label = status || 'Offline';

  let colorClasses = 'bg-zinc-800 text-zinc-300 border-zinc-700';
  let dotColor = 'bg-zinc-400';

  if (norm === 'ACTIVE') {
    colorClasses = 'bg-emerald-950/40 text-emerald-400 border-emerald-800/50';
    dotColor = 'bg-emerald-400 animate-pulse';
  } else if (norm === 'INACTIVE') {
    colorClasses = 'bg-amber-950/40 text-amber-400 border-amber-800/50';
    dotColor = 'bg-amber-400';
  } else if (norm === 'OFFLINE' || norm === 'EXPIRED') {
    colorClasses = 'bg-zinc-900 text-zinc-400 border-zinc-800';
    dotColor = 'bg-zinc-500';
  } else if (norm === 'SUSPENDED' || norm === 'REVOKED' || norm === 'DISABLED') {
    colorClasses = 'bg-rose-950/40 text-rose-400 border-rose-800/50';
    dotColor = 'bg-rose-400';
  } else if (norm === 'UNUSED' || norm === 'PENDING') {
    colorClasses = 'bg-blue-950/40 text-blue-400 border-blue-800/50';
    dotColor = 'bg-blue-400';
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${colorClasses} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`} />
      {label}
    </span>
  );
}
